import type { AggResponse } from './types';

/**
 * Copies gateway tracing headers from the HTTP response (`x-trace-id`, `atl-request-id`)
 * onto the parsed GraphQL result. The JSON body does not include these; we attach them so
 * callers can use the same trace and request IDs the gateway returned.
 */
export function enrichAggResponseWithGatewayTracingHeaders<Data>(
	response: AggResponse<Data>,
	tracingHeaders: Record<string, string>,
): AggResponse<Data> {
	if (!tracingHeaders || Object.keys(tracingHeaders).length === 0) {
		return response;
	}
	return {
		...response,
		gatewayTracingHeaders: {
			...response.gatewayTracingHeaders,
			...tracingHeaders,
		},
	};
}
